/* eslint-disable camelcase */
import { Message } from 'primereact/message';
import React, { useEffect, useState } from 'react';

import { useGetScorecardStatusQuery } from '../../pages/compensation/compensationSlice';
import './ScoreCardApprovalStatusNotification.scss';

export const ScoreCardApprovalStatusNotification = ({
    year: inputYear,
    month: inputMonth,
    scorecardversion: inputScorecardVersion,
}: any) => {
    const messageInfo = 'Please choose “All” to view and approve associates who no longer report to you';
    const [scorecardData, setScorecardData] = useState<any>([]);
    const { data: statusData } = useGetScorecardStatusQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );

    useEffect(() => {
        if (statusData?.data?.length > 0) {
            setScorecardData(statusData?.data[0]);
        }
    }, [statusData]);

    const calculateTotalPercentage = (scorecardData: any) => {
        const {
            associates_on_scorecard = 0,
            team_leads_on_scorecard = 0,
            team_leads_approved_by_manager = 0,
            associates_approved_by_manager = 0,
            disqualified_count_on_scorecard = 0
        } = scorecardData ?? {};
        const totalMembers = associates_on_scorecard + team_leads_on_scorecard;
        const approvedAndDisqualifiedAssociates = associates_approved_by_manager + team_leads_approved_by_manager + disqualified_count_on_scorecard;
        if (totalMembers === 0) {
            return 0;
        }

        const totalPercentage = (approvedAndDisqualifiedAssociates / totalMembers) * 100;
        return totalPercentage.toFixed(2);
    };

    if (!scorecardData) {
        return null;
    }

    const approavalPercentage = calculateTotalPercentage(scorecardData);
    return (
        <div className="statusContainer">
            <div className="memberStatus">
                <ul>
                    <li>
                        <span className="">Scorecard Members</span>
                        <span className="statusText">
                            {(scorecardData.associates_on_scorecard || 0) + (scorecardData.team_leads_on_scorecard || 0)}
                        </span>
                    </li>
                    <li>
                        <span className="">Manager Approved</span>
                        <span className="statusText">
                            {(scorecardData.associates_approved_by_manager || 0) +
                                (scorecardData.team_leads_approved_by_manager || 0)}
                        </span>
                    </li>
                    <li>
                        <span className="">Disqualified</span>
                        <span className="statusText">
                            {scorecardData.disqualified_count_on_scorecard || 0}
                        </span>
                    </li>
                    <li>
                        <span className="">UnApproved</span>
                        <span className={'statusText percetRed'}>
                            {scorecardData.unapproval_count_on_scorecard || 0}
                        </span>
                    </li>
                    <li>
                        <span className="">Manager % Approved</span>
                        <span className={'statusText ' + ((Number(approavalPercentage) || 0) < 75 ? 'percetRed' : '')}>
                            {approavalPercentage || 0}%
                        </span>
                    </li>
                </ul>
            </div>

            <Message
                className={'statusMessage ' + ((Number(approavalPercentage) || 0) < 75 ? 'redAlert' : '')}
                severity="info"
                text={messageInfo}
            />
        </div>
    );
};
